import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useApi } from '@blimo/api-client/react';

/** Logs out (POST /auth/logout), clears all cached data and goes to /login. */
export function useLogout() {
  const api = useApi();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return async () => {
    try {
      await api.auth.logout();
    } catch {
      // Session may already be gone – logging out locally is what matters.
    }
    queryClient.clear();
    await navigate({ to: '/login', search: { redirect: undefined } });
  };
}
